(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jmh-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('.jmh-reviews__arrow');
  if (!button) return;
  const carousel = button.closest('.jmh-reviews__carousel');
  const scroller = carousel.querySelector('.jmh-reviews__scroller');
  const card = scroller.querySelector('.jmh-review-card');
  if (!card) return;
  const gap = 16;
  const direction = button.classList.contains('jmh-reviews__arrow--next') ? 1 : -1;
  scroller.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap) * 3, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
